// ── Constantes ─────────────────────────────────────────────────────

export const AUTONOMY_OPTIONS = [
	{ value: "assistant", label: "Assistente (Sempre pede confirmação)" },
	{ value: "collaborator", label: "Colaborador (Confirma apenas ações sensíveis)" },
	{ value: "autonomous", label: "Autônomo (Execução livre)" },
];

export const MEMBER_STATUS_MAP: Record<string, { label: string; className: string }> = {
	disponivel: { label: "Disponível", className: "statusActive" },
	executando: { label: "Em execução", className: "statusPending" },
	descansando: { label: "Descansando", className: "statusPending" },
	erro: { label: "Erro", className: "statusInactive" },
};
